<form [formGroup]="reservationSelectForm">
<span class="p-float-label required-field w-100 mb-3">
  <p-autoComplete
      [suggestions]="reservationSuggestions"
      [multiple]="false"
      [forceSelection]="true"
      [dropdown]="false"
      [style]="{'width':'100%','padding-bottom':'20px'}"
      [inputStyle]="{'width':'100%'}"
      [minLength]="2"
      formControlName="reservation"
      unique="true"
      field="summary"
      name="reservation"
	  id="reservation"
      (onSelect)="onSelect($event)"
      (onUnselect)="onUnselect($event)"
      (onKeyUp)="onKeyUp($event)"
      (completeMethod)="onKeyInput($event)">
      </p-autoComplete>
	<label for="reservation">{{placeholder}}</label>
</span>
  </form>